module.exports = __webpack_public_path__ + "img/_ABS9803.91e95ef4.jpg";